import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from '../components/layout/MainLayout';
import AuthLayout from '../components/layout/AuthLayout';
import PrivateRoute from './PrivateRoute';
import Home from '../pages/Home/Home';
import CategoryPage from '../pages/CategoryPage/CategoryPage';
import SubcategoryPage from '../pages/Subcategory/SubcategoryPage';
import SubSubcategoryPage from '../pages/SubSubcategory/SubSubcategoryPage';
import ProductDetailsPage from '../pages/ProductDetails/productDetailspage';
import VendorCategoryPage from "../components/common/VendorCategoryPage/VendorCategoryPage"

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        {/* <Route path="/cart" element={<Cart />} /> */}
        <Route path="/category/:categorySlug" element={<CategoryPage />} />
        <Route path="/category/:categorySlug/:subcategorySlug" element={<SubcategoryPage />} />
        <Route path="/category/:categorySlug/:subcategorySlug/:subSubcategorySlug" element={<SubSubcategoryPage />} />
        <Route path="/product/:productUuid" element={<ProductDetailsPage />} />
        <Route path="/vendor/:vendorId" element={<VendorCategoryPage />} />
      </Route>

      <Route element={<AuthLayout />}>
        {/* <Route path="/login" element={<Login />} /> */}
      </Route>

      <Route element={<PrivateRoute />}>
        <Route element={<MainLayout />}>
          {/* <Route path="/orders" element={<Orders />} /> */}
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRoutes;